import React from 'react';
import {Button} from '@mui/material';
import LoginIcon from '@mui/icons-material/Login';

const Login = ({ login }) => {
    return (
        <div className='login_container'>
            <div className='login_logo'>
                <div className='logo_values'>
                    <div className='subtext_login gucci_text'>
                        GUCCI
                    </div>
                    <div className='text_login gucci_text_bold'>
                        Showroom
                    </div>
                    <Button
                        className='login_button'
                        onClick={login}
                        color="primary"
                        startIcon={<LoginIcon className='login_icon' />}
                    >
                        Login
                    </Button>
                </div>
            </div>
            <div className='app_version'>v1.0.9</div>
        </div>
    );
};

export default Login;
